import React from "react";

export default function Footer() {
  return (
    <footer className="dashboard-footer">
      <div className="footer-left">
        © {new Date().getFullYear()} Dwellium. All Rights Reserved.
      </div>

      <div className="footer-right">
        <span>Travel Management System</span>
      </div>
    </footer>
  );
}